import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { LOCALE_ID, NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { WelcomeComponent } from './welcome/welcome.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
// import { ModalModule } from './utils/custom-modal/modal.module';
// import { MathJaxModule } from 'ngx-mathjax';
import { MatButtonModule } from '@angular/material/button';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatIconModule } from '@angular/material/icon';
import { QuillModule } from 'ngx-quill';
import { enableProdMode } from '@angular/core';
import { environment } from './../environments/environment';
import { MatCardModule } from '@angular/material/card';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { FooterModule } from './footer/footer.module';

// import { NgxYoutubePlayerModule } from 'ngx-youtube-player';
import { ModalService } from './utils/custom-modal/modal.service';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
// import { ContentBuilderComponent } from './utils/content-builder/content-builder.component';
// import { CustomAlertComponent } from './collection_process/utils/custom-alert/custom-alert.component';

import { MsalModule, MsalService, MSAL_INSTANCE } from '@azure/msal-angular';
import { IPublicClientApplication, PublicClientApplication } from '@azure/msal-browser';
import { ServiceWorkerModule } from '@angular/service-worker';
const isIE = window.navigator.userAgent.indexOf('MSIE ') > -1 || window.navigator.userAgent.indexOf('Trident/') > -1;


export function MSALInstanceFactory(): IPublicClientApplication {

  return new PublicClientApplication({
    auth: {
      clientId: '05a2537d-5147-4aec-8149-ba6f1646c40f', // This is your client ID
      //authority: 'https://login.microsoftonline.com/bc6a962a-1345-44ee-a72c-2418aca1b627', // This is your tenant ID
      redirectUri: 'http://localhost:4200'// This is your redirect URI
    },
    cache: {
      cacheLocation: 'localStorage',
      storeAuthStateInCookie: isIE, // Set to true for Internet Explorer 11
    }
  });
}

enableProdMode();

@NgModule({
  declarations: [
    AppComponent, WelcomeComponent

    // PdfViewerModule
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MatCardModule,
    MatSnackBarModule,
    MatButtonModule,
    MatToolbarModule,
    MatIconModule,
    QuillModule,
    MatDatepickerModule,
    MatNativeDateModule,
    FooterModule,
    MsalModule.forRoot(new PublicClientApplication({
      auth: {
        clientId: 'dddcf37a-d7fd-4fd0-8326-1ae0f1f7bcee',
        //clientId: '05a2537d-5147-4aec-8149-ba6f1646c40f', // This is your client ID
        //authority: 'https://login.microsoftonline.com/bc6a962a-1345-44ee-a72c-2418aca1b627', // This is your tenant ID
        authority: 'https://login.microsoftonline.com/common', // This is your tenant ID
        redirectUri: 'https://isfodosu-sql.web.app',// This is your redirect URI
        postLogoutRedirectUri: 'https://isfodosu-sql.web.app/start-screen',
      },
      cache: {
        cacheLocation: 'localStorage',
        storeAuthStateInCookie: isIE, // Set to true for Internet Explorer 11
      }
    }), null, null),

    NgbModule,
   /*  ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000'
    }), */

  ],
  providers: [MatDatepickerModule, { provide: LOCALE_ID, useValue: 'en-US' },
    { provide: 'BACKEND_URL', useValue: environment.apiUrl },
    { provide: 'FRONTEND_URL', useValue: environment.frontendUrl },
    { provide: 'PROJECT_NAME', useValue: environment.projectName },
    ModalService,
    /*  { provide: MSAL_INSTANCE, useValue: environment.projectName },
     MsalService */
    // PdfViewerComponent
  ], // DEBUG OR PRODUCTION
  bootstrap: [AppComponent],
  exports: [BrowserAnimationsModule, MatSnackBarModule,

    // NgxEpicVideoPlayerModule

  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],

})
export class AppModule { }


/*
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
*/